import type { WebfunnelLinkDTO } from '../api/types';
import type { ProductWebfunnelLink, WebLinkType } from '../model/types';

export const mapWebfunnelLink = (
  dto: WebfunnelLinkDTO,
): ProductWebfunnelLink => {
  return {
    id: dto.id,
    url: dto.webUrl,
    type: dto.linkType as WebLinkType,
    productId: dto.productId,
    createdAt: dto.createdAt,
    updatedAt: dto.updatedAt,
  };
};
